import React, { useState, useRef, useEffect } from "react";
import styles from "./inadimplenciaCard.module.css";
import InfoIcon from "../../../assets/icons/info-icon.svg";
import { formatNumberToCurrency } from "../../../utils/formatter";

const InadimplenciaCard = ({ 
  inadimplenciaData = null, 
  icon, 
  title = "",
  explanation = "",
  code
}) => {
  const [showPopover, setShowPopover] = useState(false);
  const popRef = useRef(null);

  // Log para debug - verificar dados recebidos
  console.log(`InadimplenciaCard [${inadimplenciaData?.tipo || 'Unknown'}]:`, inadimplenciaData);

  // Verifica se há dados válidos
  const hasNoData = !inadimplenciaData || (
    !inadimplenciaData.resultado && 
    !inadimplenciaData.courseTitle &&
    inadimplenciaData.valorAtraso === undefined && 
    inadimplenciaData.percentualInad === undefined &&
    inadimplenciaData.valor === undefined &&
    inadimplenciaData.issuedValue === undefined
  );

  useEffect(() => {
    if (showPopover && popRef.current) {
      const rect = popRef.current.getBoundingClientRect();
      if (rect.right > window.innerWidth - 8) {
        popRef.current.style.left = `-${rect.width + 8}px`;
      } else {
        popRef.current.style.left = '100%';
      }
    }
  }, [showPopover]);



  if (hasNoData) {
    return (
      <div className={styles.inadimplenciaCard}>
        {code && <span className={styles.code}>{code}</span>}
        <img src={icon} alt="" className={styles.icon} />
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <h6 className={styles.title}>{inadimplenciaData?.tipo || title || "Inadimplência"}</h6>
            {explanation && (
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <img
                  src={InfoIcon}
                  alt="Informação"
                  style={{ cursor: 'pointer', width: 14, height: 14 }}
                  onClick={() => setShowPopover(prev => !prev)}
                />
                {showPopover && (
                  <div
                    ref={popRef}
                    className={styles.popover}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: '100%',
                      marginLeft: 8,
                      zIndex: 100,
                    }}
                  >
                    <p style={{ margin: 0 }}>{explanation}</p>
                    <button
                      type="button"
                      className={styles.closeBtn}
                      onClick={() => setShowPopover(false)}
                    >
                      Fechar
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          <h2 className={styles.value}>Nenhum dado encontrado</h2>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.inadimplenciaCard}>
      {code && <span className={styles.code}>{code}</span>}
      <img src={icon} alt="" className={styles.icon} />
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <h6 className={styles.title}>{inadimplenciaData.tipo || title || "Inadimplência"}</h6>
          {explanation && (
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <img
                src={InfoIcon}
                alt="Informação"
                style={{ cursor: 'pointer', width: 14, height: 14 }}
                onClick={() => setShowPopover(prev => !prev)}
              />
              {showPopover && (
                <div
                  ref={popRef}
                  className={styles.popover}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: '100%',
                    marginLeft: 8,
                    zIndex: 100,
                  }}
                >
                  <p style={{ margin: 0 }}>{explanation}</p>
                  <button
                    type="button"
                    className={styles.closeBtn}
                    onClick={() => setShowPopover(false)}
                  >
                    Fechar
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        <h2 className={styles.value}>
          {inadimplenciaData.valorAtraso !== undefined 
            ? formatNumberToCurrency(inadimplenciaData.valorAtraso)
            : inadimplenciaData.valor !== undefined 
              ? formatNumberToCurrency(inadimplenciaData.valor)
              : inadimplenciaData.issuedValue !== undefined
                ? formatNumberToCurrency(inadimplenciaData.issuedValue)
                : inadimplenciaData.percentualInad !== undefined
                  ? `${inadimplenciaData.percentualInad.toFixed(2)}%`
                  : 'N/A'
          }
        </h2>
        {(inadimplenciaData.resultado || inadimplenciaData.aluno || inadimplenciaData.alunoNome || inadimplenciaData.courseTitle) && (
          <p className={styles.resultText}>
            {inadimplenciaData.resultado || inadimplenciaData.aluno || inadimplenciaData.alunoNome || inadimplenciaData.courseTitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default InadimplenciaCard;
